<script>
import constants from "@/configs/constant";
import {mapGetters} from "vuex";
import DatePicker from "vue2-datepicker";
const REGULARLY_RESERVATION_WEEKLY = 1;
const REGULARLY_RESERVATION_BIWEEKLY = 2;
const REGULARLY_RESERVATION_MONTHLY = 3;
export default {
  name: "schedule_regular_interval_information_by_car_manager",
  props: {
    dataSelected: {
      type: Object,
      required: true
    },
    errors: {
      type: Object,
      default: () => {},
    },
    disabled: {
      type: Boolean,
      default: true,
    },
  },
  components: {
    DatePicker,
  },
  data() {
    return {
      msgError: {},
    }
  },
  methods: {
    disabledDateForStartDate: function (date) {
      return date.setHours(0, 0, 0, 0) < new Date().setHours(0, 0, 0, 0);
    },
  },
  computed: {
    ...mapGetters("options", ["options_tables"]),
    days_of_the_week() {
      return constants.DAY_OF_WEEKS;
    },
    isDateOfMonth() {
      return this.dataSelected.zz_regularly_reservation_interval_id == REGULARLY_RESERVATION_MONTHLY ? true : false;
    },
    isDateOfWeek() {
      return this.dataSelected.zz_regularly_reservation_interval_id == REGULARLY_RESERVATION_WEEKLY
      || this.dataSelected.zz_regularly_reservation_interval_id == REGULARLY_RESERVATION_BIWEEKLY ? true : false;
    },
    checkValidate() {
      if (this.dataSelected.schedule_type == RESERVATION_DATES) return true;
      let data = this.dataSelected;
      if (this.isDateOfMonth && (!data.regularly_reservation_date_of_month || data.regularly_reservation_date_of_month < 1 || data.regularly_reservation_date_of_month > 31)) return false;
      if (this.isDateOfWeek && !data.regularly_reservation_day_of_week.length) return false;
      if (!data.regularly_reservation_start_date) return false;
      if (!data.regularly_reservation_end_date) return false;
      if (!data.zz_regularly_reservation_interval_id) return false;
      if (!data.zz_day_of_time_zone_id) return false;

      return true;
    },
  }
}
</script>

<template>
  <div class="d-flex flex-column">
    <div class="mb-1">
      <ValidationObserver v-slot="{ invalid }" ref='observer'>
        <b-row class="select-date">
          <b-col cols="1 align-self-center" class="text-nowrap me-4">開始年月日</b-col>
          <b-col cols="4">
            <div class="custom-datepicker gap-2">
              <div class="input-control" :class="msgError.regularly_reservation_start_date ? 'invalid ': ''">
                <date-picker
                  v-model="dataSelected.regularly_reservation_start_date"
                  lang="ja"
                  placeholder="YYYY-MM-DD"
                  format="YYYY-MM-DD"
                  value-type="YYYY-MM-DD"
                  position="left"
                  :disabled-date="disabledDateForStartDate"
                  :disabled="disabled"
                  :clearable="false"
                  :editable="false"
                ></date-picker>
                <span>{{msgError.regularly_reservation_start_date}}</span>
              </div>
            </div>
            <div
              v-if="errors[`regular_interval_information.regularly_reservation_start_date`]"
              class="error-message text-nowrap"
            >
              {{ errors[`regular_interval_information.regularly_reservation_start_date`][0] }}
            </div>
          </b-col>
          <b-col cols="1" class="split text-center">
            <span>～</span>
          </b-col>
          <b-col cols="1 align-self-center" class="text-nowrap me-4">終了年月日</b-col>
          <b-col cols="4">
            <div class="custom-datepicker gap-2">
              <div class="input-control" :class="msgError.regularly_reservation_end_date ? 'invalid ': ''">
                <date-picker
                  v-model="dataSelected.regularly_reservation_end_date"
                  lang="ja"
                  placeholder="YYYY-MM-DD"
                  format="YYYY-MM-DD"
                  value-type="YYYY-MM-DD"
                  :disabled-date="disabledDateForStartDate"
                  position="left"
                  :disabled="disabled"
                  :clearable="false"
                  :editable="false"
                ></date-picker>
                <span>{{msgError.regularly_reservation_end_date}}</span>
              </div>
            </div>
            <div
              v-if="errors[`regular_interval_information.regularly_reservation_end_date`]"
              class="error-message text-nowrap"
            >
              {{ errors[`regular_interval_information.regularly_reservation_end_date`][0] }}
            </div>
          </b-col>
        </b-row>
        <b-row class="mt-2">
          <b-col cols="1 align-self-center" class="text-nowrap me-4">作業時間</b-col>
          <b-col class="d-flex gap-2 col-4 align-items-baseline">
            <div>
              <date-picker
                v-model="dataSelected.start_time"
                type="time"
                placeholder="HH:mm"
                format="HH:mm"
                value-type="HH:mm"
                position="left"
                :disabled="disabled"
                :clearable="false"
                :editable="true"
              ></date-picker>
              <div
                v-if="errors[`regular_interval_information.start_time`]"
                class="error-message text-nowrap"
              >
                {{ errors[`regular_interval_information.start_time`][0] }}
              </div>
            </div>
            <div class="align-self-center">～</div>
            <div>
              <date-picker
                v-model="dataSelected.end_time"
                type="time"
                placeholder="HH:mm"
                format="HH:mm"
                value-type="HH:mm"
                position="left"
                :disabled="disabled"
                :clearable="false"
                :editable="true"
              ></date-picker>
              <div
                v-if="errors[`regular_interval_information.end_time`]"
                class="error-message text-nowrap"
              >
                {{ errors[`regular_interval_information.end_time`][0] }}
              </div>
            </div>
          </b-col>
        </b-row>
        <div class="d-flex mt-2">
          <div class="d-flex align-items-center me-3">
            <div class="custom-radio-group d-flex justify-content-center align-items-center">
              <label for="works_periodically" class="text-nowrap">頻度</label>
              <b-form-radio-group
                class="radio-group"
                id="works_periodically"
                v-model="dataSelected.zz_regularly_reservation_interval_id"
                name="work-order-types-options"
                :disabled="disabled"
              >
                <b-form-radio
                  v-for="option in options_tables.zz_regularly_reservation_intervals"
                  :value="option.id"
                  disabled-field="notEnabled"
                  :disabled="disabled"
                >{{ option.regularly_reservation_interval }}
                </b-form-radio>
              </b-form-radio-group>
            </div>
          </div>
          <div>
            <div class="input-control">
              <div class="custom-input number-of-date gap-2">
                <b-form-group v-slot="{ ariaDescribedby }">
                  <div class="input-control">
                    <b-form-input
                      type="number"
                      class="d-flex gap-3"
                      v-model="dataSelected.regularly_reservation_date_of_month"
                      name="number-of-date"
                      :disabled="!isDateOfMonth || disabled"
                      :aria-describedby="ariaDescribedby"
                      min="1"
                    >
                    </b-form-input>
                  </div>
                  <div
                    v-if="errors[`regular_interval_information.regularly_reservation_date_of_month`]"
                    class="error-message text-nowrap"
                  >
                    {{ errors[`regular_interval_information.regularly_reservation_date_of_month`][0] }}
                  </div>
                </b-form-group>
                <div class="align-self-center">日</div>
              </div>
            </div>
          </div>
        </div>
        <b-row>
          <div class="custom-checkbox-core">
            <b-form-group v-slot="{ ariaDescribedby }">
              <div class="input-control">
                <b-form-checkbox-group
                  :disabled="!isDateOfWeek || disabled"
                  id="checkbox-group-days-of-the-week"
                  class="d-flex gap-3"
                  v-model="dataSelected.regularly_reservation_day_of_week"
                  :options="days_of_the_week"
                  :aria-describedby="ariaDescribedby"
                  name="checkbox-group-days-of-the-week"
                ></b-form-checkbox-group>
              </div>
              <div
                v-if="errors[`regular_interval_information.regularly_reservation_day_of_week`]"
                class="error-message text-nowrap"
              >
                {{ errors[`regular_interval_information.regularly_reservation_day_of_week`][0] }}
              </div>
            </b-form-group>
          </div>
        </b-row>
      </ValidationObserver>
    </div>
  </div>
</template>

<style scoped lang="scss">
.select-date {
  .split {
    font-size: 25px;
  }
}

.custom-datepicker label {
  align-self: unset;
}

.input-control.invalid span {
  white-space: nowrap;
}
</style>
